"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Order extends Parse.Object {
    constructor(attributes) {
        super('Order', attributes);
    }
    get statusChanges() { return this.get('statusChanges'); }
    set statusChanges(value) { this.set('statusChanges', value); }
    get canAcceptBoleto() { return this.get('canAcceptBoleto'); }
    set canAcceptBoleto(value) { this.set('canAcceptBoleto', value); }
    /** How the boleto will be created for this order */
    get boletoInstructions() { return this.get('boletoInstructions'); }
    set boletoInstructions(value) { this.set('boletoInstructions', value); }
    get canAcceptCreditCard() { return this.get('canAcceptCreditCard'); }
    set canAcceptCreditCard(value) { this.set('canAcceptCreditCard', value); }
    /** How the credit card payment will be created for this order */
    get creditCardInstructions() { return this.get('creditCardInstructions'); }
    set creditCardInstructions(value) { this.set('creditCardInstructions', value); }
    get customer() { return this.get('customer'); }
    set customer(value) { this.set('customer', value); }
    get deliveryTime() { return this.get('deliveryTime'); }
    set deliveryTime(value) { this.set('deliveryTime', value); }
    get freightCost() { return this.get('freightCost'); }
    set freightCost(value) { this.set('freightCost', value); }
    /**
     * When the retailer.freightCalculation.mode is set to Automatic then the
     * salesperson may choose to adjust the shipping cost on his own
     */
    get freightCostAdjusted() { return this.get('freightCostAdjusted'); }
    set freightCostAdjusted(value) { this.set('freightCostAdjusted', value); }
    /**  How the discount has been applied. */
    get discountMode() { return this.get('discountMode'); }
    set discountMode(value) { this.set('discountMode', value); }
    /**  The discount, regardless the discountMode it is always abosolute. */
    get discount() { return this.get('discount'); }
    set discount(value) { this.set('discount', value); }
    get installmentsWithoutInterest() { return this.get('installmentsWithoutInterest'); }
    set installmentsWithoutInterest(value) { this.set('installmentsWithoutInterest', value); }
    /** Installments that the customer have chosen to pay for this order */
    get paymentInstallmentsCount() { return this.get('paymentInstallmentsCount'); }
    set paymentInstallmentsCount(value) { this.set('paymentInstallmentsCount', value); }
    get items() { return this.get('items'); }
    set items(value) { this.set('items', value); }
    get notes() { return this.get('notes'); }
    set notes(value) { this.set('notes', value); }
    get pickUpInStore() { return this.get('pickUpInStore'); }
    set pickUpInStore(value) { this.set('pickUpInStore', value); }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get retailerOrderId() { return this.get('retailerOrderId'); }
    get user() { return this.get('user'); }
    set user(value) { this.set('user', value); }
    get shippingAddress() { return this.get('shippingAddress'); }
    set shippingAddress(value) { this.set('shippingAddress', value); }
    get shippingMethod() { return this.get('shippingMethod'); }
    set shippingMethod(value) { this.set('shippingMethod', value); }
    get freeShipping() { return this.get('freeShipping'); }
    set freeShipping(value) { this.set('freeShipping', value); }
    get salesPerson() { return this.get('salesPerson'); }
    set salesPerson(value) { this.set('salesPerson', value); }
    get paymentMethod() { return this.get('paymentMethod'); }
    set paymentMethod(value) { this.set('paymentMethod', value); }
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    get statusTracking() { return this.get('statusTracking'); }
    set statusTracking(value) { this.set('statusTracking', value); }
    get orderGwId() { return this.get('orderGwId'); }
    set orderGwId(value) { this.set('orderGwId', value); }
    /** id referente a este objeto quando integrado com um gateway externo */
    get externalId() { return this.get('externalId'); }
    set externalId(value) { this.set('externalId', value); }
    /** id referente a este objeto quando integrado com um gateway externo */
    get parentOrder() { return this.get('parentOrder'); }
    set parentOrder(value) { this.set('parentOrder', value); }
    /** id referente a este objeto quando integrado com um gateway externo */
    get isInternational() { return this.get('isInternational'); }
    set isInternational(value) { this.set('isInternational', value); }
    get paymentGatewayMoip() { return this.get('paymentGatewayMoip'); }
    set paymentGatewayMoip(value) { this.set('paymentGatewayMoip', value); }
    /**
     * add object invoice to order
     */
    get invoice() { return this.get('invoice'); }
    set invoice(value) { this.set('invoice', value); }
    /**
     * from which team this order is originated from
     */
    get team() { return this.get('team'); }
    set team(value) { this.set('team', value); }
    get shippingTrackingURL() { return this.get('shippingTrackingURL'); }
    set shippingTrackingURL(value) { this.set('shippingTrackingURL', value); }
    get installmentsWithInterest() { return this.get('installmentsWithInterest'); }
    set installmentsWithInterest(value) { this.set('installmentsWithInterest', value); }
    get interest() { return this.get('interest'); }
    set interest(value) { this.set('interest', value); }
    get tax() { return this.get('tax'); }
    set tax(value) { this.set('tax', value); }
    get creditCardInstallments() { return this.get('creditCardInstallments'); }
    set creditCardInstallments(value) { this.set('creditCardInstallments', value); }
    get isCreatingMultiBoleto() { return this.get('isCreatingMultiBoleto'); }
    set isCreatingMultiBoleto(value) { this.set('isCreatingMultiBoleto', value); }
    get sourceApp() { return this.get('sourceApp'); }
    set sourceApp(value) { this.set('sourceApp', value); }
    /**
     * mark order as a favorite one
     */
    get favorite() { return this.get('favorite'); }
    set favorite(value) { this.set('favorite', value); }
    /**
     * which integration should be used to process this order
     */
    get paymentGatewayIntegration() { return this.get('paymentGatewayIntegration'); }
    set paymentGatewayIntegration(value) { this.set('paymentGatewayIntegration', value); }
    /**
     * which mundipagg should be used
     */
    get paymentGatewayMundipagg() { return this.get('paymentGatewayMundipagg'); }
    set paymentGatewayMundipagg(value) { this.set('paymentGatewayMundipagg', value); }
    /**
     * Payment Details
     */
    get paymentDetail() { return this.get('paymentDetail'); }
    set paymentDetail(value) { this.set('paymentDetail', value); }
    /**
   * The channel used by the user to create this order
   */
    get salesChannel() { return this.get('salesChannel'); }
    set salesChannel(value) { this.set('salesChannel', value); }
    /** Mongo dashboard calculated fields */
    /* Order total value */
    get totalFetched() {
        return this.get('totalFetched');
    }
    set totalFetched(value) {
        this.set('totalFetched', value);
    }
    /* Order items value */
    get subtotalFetched() {
        return this.get('subtotalFetched');
    }
    set subtotalFetched(value) {
        this.set('subtotalFetched', value);
    }
    /* Fetched salesPerson attributes */
    get salesPersonFetched() {
        return this.get('salesPersonFetched');
    }
    set salesPersonFetched(value) {
        this.set('salesPersonFetched', value);
    }
    /* Fetched team attributes */
    get teamFetched() {
        return this.get('teamFetched');
    }
    set teamFetched(value) {
        this.set('teamFetched', value);
    }
    /* If order is paid */
    get isPaid() {
        return this.get('isPaid');
    }
    set isPaid(value) {
        this.set('isPaid', value);
    }
    totalAmountItems() {
        return this.subtotal();
    }
    subtotal() {
        let total = 0;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            if (item.price) {
                total += item.price * item.quantity;
            }
        }
        return total;
    }
    total() {
        let total = this.subtotal();
        if (this.freightCost) {
            total += this.freightCost;
        }
        if (this.discount) {
            total -= this.discount;
        }
        return total;
    }
    get checkoutUrl() { return this.get('checkoutUrl'); }
    set checkoutUrl(value) { this.set('checkoutUrl', value); }
    get paymentGatewayConfiguration() { return this.get('paymentGatewayConfiguration'); }
    set paymentGatewayConfiguration(value) { this.set('paymentGatewayConfiguration', value); }
}
exports.Order = Order;
Parse.Object.registerSubclass('Order', Order);
//# sourceMappingURL=Order.js.map